import { Action } from '@ngrx/store';
import { PaginatedResult } from 'src/app/models/paginated-result.model';
import { Ticket } from 'src/app/models/ticket/ticket.model';

// Load tickets
export const LOAD_TICKETS = '[Tickets] Load Tickets';
export const LOAD_TICKETS_FAIL = '[Tickets] Load Tickets Fail';
export const LOAD_TICKETS_SUCCESS = '[Tickets] Load Tickets Success';

export class LoadTickets implements Action {
  readonly type = LOAD_TICKETS;

  constructor(public payload: { page?: number; pageSize?: number } = {}) {}
}

export class LoadTicketsFail implements Action {
  readonly type = LOAD_TICKETS_FAIL;

  constructor(public payload: { error: string }) {}
}

export class LoadTicketsSuccess implements Action {
  readonly type = LOAD_TICKETS_SUCCESS;

  constructor(public payload: PaginatedResult<Ticket>) {}
}

export const CLEAR_TICKETS = '[Tickets] Clear Tickets';
export const SET_SELECTED_TICKET = '[Tickets] Set Selected Ticket';

export class ClearTickets implements Action {
  readonly type = CLEAR_TICKETS;
}

export class SetSelectedTicket implements Action {
  readonly type = SET_SELECTED_TICKET;

  constructor(public payload: string | null) {}
}

export const UPDATE_TICKET = '[Tickets] Update Ticket';

export class UpdateTicket implements Action {
  readonly type = UPDATE_TICKET;

  constructor(public payload: Ticket) {}
}

// action types
export type TicketsAction =
  | LoadTickets
  | LoadTicketsFail
  | LoadTicketsSuccess
  | ClearTickets
  | SetSelectedTicket
  | UpdateTicket;
